import { ChangeDetectorRef, Directive, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService, CanComponentDeactivate } from '@klickdata/core/auth';
import { Resource, ResourceService, ResourceTypes } from '@klickdata/core/resource';
import { User } from '@klickdata/core/user';
import { ResourceManagementComponent } from '@klickdata/shared-components/src/resource-manager/resource-manager.component';
import { Observable, Subject, of } from 'rxjs';
import { first, shareReplay, switchMap, takeUntil } from 'rxjs/operators';

@Directive()
export abstract class ResourceContainerDirective implements OnInit, OnDestroy, CanComponentDeactivate {
    ResourceTypes = ResourceTypes;
    public destroy: Subject<boolean> = new Subject<boolean>();

    public resource$: Observable<Resource>;
    public user$: Observable<User>;

    abstract fieldsLabels: { [key: string]: string }[];
    abstract resourceManagerComp: ResourceManagementComponent;

    protected route = inject(ActivatedRoute);
    protected resourceService = inject(ResourceService);
    protected cdr = inject(ChangeDetectorRef);
    protected auth = inject(AuthService);

    ngOnInit(): void {
        this.user$ = this.auth.getUser().pipe(first());
        this.resource$ = this.route.params.pipe(
            switchMap((params) => {
                if (params.resourceId && Number(params.resourceId)) {
                    return this.resourceService.getResourceWithParams(
                        params.resourceId,
                        { editing: true },
                        this.getEager()
                    );
                }
                return of(null);
            }),
            shareReplay(),
            takeUntil(this.destroy)
        );
    }

    public ngOnDestroy(): void {
        this.destroy.next(true);
        this.destroy.unsubscribe();
    }

    public canDeactivate(): boolean {
        return this.resourceManagerComp ? this.resourceManagerComp.canDeactivate() : true;
    }

    public saveAndDeactivate(): Observable<boolean> {
        return this.resourceManagerComp.saveAndDeactivate();
    }

    abstract openResourceListing(): void;

    private getEager(): string[] {
        return [...this.getDefaultEager(), ...this.getExtraEager()];
    }

    private getDefaultEager(): string[] {
        return ['publication', 'publishment', 'editors', 'tags'];
    }

    protected getExtraEager(): string[] {
        return [];
    }
}
